// extracted by mini-css-extract-plugin
export default {"survey":"questionslist_survey__s9b3O"};